import { render, staticRenderFns } from "./UpperSidebarLink.vue?vue&type=template&id=1095b158&scoped=true&"
import script from "./UpperSidebarLink.vue?vue&type=script&lang=js&"
export * from "./UpperSidebarLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095b158",
  null
  
)

export default component.exports